<template>
    <v-container class="py-7">
        <v-row>
            <v-col cols="12">
                <div class="title-container">
                    <div class="title-block">
                        <span id="title" class="page-title">Avaliações</span>
                        <v-breadcrumbs class="app-breadcrumb" divider="›" :items="breadcrumbItems"></v-breadcrumbs>
                    </div>
                    <div class="button-group">
                        <v-btn id="btnNew" type="button" color="primary" elevation="0" to="/avaliacoes/novo">Incluir</v-btn>
                    </div>
                </div>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="12">
                <v-card class="filter-card">
                    <v-card-title class="filter-card-title">Filtro</v-card-title>
                    <v-card-text>
                        <v-form @submit.prevent="load()">
                            <v-row>
                                <v-col cols="12" md="3">
                                    <v-text-field dense label="Título" v-model="dataList.filter.name" hide-details outlined />
                                </v-col>
                                <v-col cols="12" md="3">
                                    <v-select dense label="Turma" :items="dataset.classes" item-text="name" item-value="id"
                                        v-model="dataList.filter.class_id" hide-details outlined clearable />
                                </v-col>
                                <v-col cols="12" md="3">
                                    <v-select dense label="Componente curricular" :items="dataset.courses" item-text="name" item-value="id"
                                        v-model="dataList.filter.course_id" hide-details outlined clearable />
                                </v-col>
                                <v-col cols="12" md="3">
                                    <v-select dense label="Período" :items="dataset.periods" item-text="name" item-value="id"
                                        v-model="dataList.filter.period_id" hide-details outlined clearable />
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12">
                                    <v-btn id="btnFilter" type="submit" color="primary" dark elevation="2">Filtrar</v-btn>
                                </v-col>
                            </v-row>
                        </v-form>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="12">
                <v-card class="table-card">
                    <v-card-title class="table-card-title">Avaliações</v-card-title>
                    <v-card-text>
                        <v-data-table :headers="dataList.headers" :items="dataList.data"
                            :server-items-length="dataList.count" @update:items-per-page="pageSizeChanged"
                            @update:page="pageChanged" :disable-sort="true" :loading="dataList.loading"
                            no-data-text="Nenhuma avaliação foi encontrada" loading-text="Carregando dados..."
                            class="app-table hover-table" :options.sync="dataList.options"
                            :footer-props="dataList.footerOptions">

                            <template v-slot:[`item.type`]="{ item }">
                                <v-chip label small>{{ assessmentTypeLabel(item.type) }}</v-chip>
                            </template>

                            <template v-slot:[`item.class`]="{ item }">
                                {{ item.class ? item.class.name : "-" }}
                            </template>

                            <template v-slot:[`item.course`]="{ item }">
                                {{ item.course ? item.course.name : "-" }}
                            </template>

                            <template v-slot:[`item.period`]="{ item }">
                                {{ item.period ? item.period.name : "-" }}
                            </template>

                            <template v-slot:[`item.end_date`]="{ item }">
                                {{ item.end_date | defaultDate("DD/MM/YYYY") }}
                            </template>

                            <template v-slot:[`item.actions`]="{ item }">
                                <v-row align="center">
                                    <v-icon @click="viewItem(item)" size="large" class="me-2">mdi-pencil-outline</v-icon>
                                    <v-icon @click="deleteItem(item)" size="large" class="me-2">mdi-delete</v-icon>
                                </v-row>
                            </template>
                        </v-data-table>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import axios from "axios";
import object from "@/common/util/object";

export default {
    name: "AssessmentList",

    data: () => ({
        breadcrumbItems: [
            { text: "Homepage", disabled: false, to: "/home", exact: true },
            { text: "Avaliações", disabled: true, exact: true },
        ],
        dataset: {
            classes: [],
            courses: [],
            periods: [],
            assessmentTypes: [
                { id: 1, name: "Prova" },
                { id: 2, name: "Trabalho" },
                { id: 3, name: "Atividade" },
                { id: 4, name: "Recuperação" },
            ],
        },
        dataList: {
            filter: {
                name: "",
                class_id: null,
                course_id: null,
                period_id: null,
            },
            headers: [
                { text: "Título", value: "title" },
                { text: "Tipo", value: "type" },
                { text: "Turma", value: "class" },
                { text: "Componente curricular", value: "course" },
                { text: "Período", value: "period" },
                { text: "Entrega", value: "end_date" },
                { text: "Ações", value: "actions", sortable: false },
            ],
            data: [],
            loading: false,
            count: 0,
            options: { page: 1, size: 10, sortBy: ["title"], sortDesc: [false] },
            footerOptions: {
                itemsPerPageText: "Itens por página:",
                itemsPerPageOptions: [10, 20, 30, 40, 50],
                pageText: "{0}-{1} de {2}",
            },
        },
    }),

    created() {
        this.loadLookups();
        this.load();
    },

    methods: {
        async loadLookups() {
            const params = { page: 1, limit: 100000, search: {} };
            const [classes, courses, periods] = await Promise.all([
                axios.get("/api/v1/classes", { params }),
                axios.get("/api/v1/courses", { params }),
                axios.get("/api/v1/academic-periods", { params }),
            ]);

            this.dataset.classes = classes.data.content.data;
            this.dataset.courses = courses.data.content.data;
            this.dataset.periods = periods.data.content.data;
        },

        pageChanged(page) {
            this.dataList.options.page = page;
            this.load();
        },

        pageSizeChanged(size) {
            this.dataList.options.size = size;
            this.load();
        },

        assessmentTypeLabel(type) {
            const item = this.dataset.assessmentTypes.find((x) => x.id == type);
            return item ? item.name : "Avaliação";
        },

        async load() {
            let search = Object.fromEntries(Object.entries(this.dataList.filter).filter(([_, value]) => value));
            search = !object.isEmpty(search) ? search : null;

            this.dataList.loading = true;

            try {
                const result = await axios.get("/api/v1/assessments", {
                    params: { page: this.dataList.options.page, limit: this.dataList.options.size, search },
                });

                this.dataList.data = result.data.content.data;
                this.dataList.count = result.data.content.paging.total;
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), { position: "top-right", timeout: 5000 });
            } finally {
                this.dataList.loading = false;
            }
        },

        viewItem(item) {
            this.$router.push(`/avaliacoes/${item.id}`);
        },

        async deleteItem(item) {
            if (!item || !item.id) return;

            const proceedAction = await this.$dialog.confirm({
                text: "Tem certeza que deseja continuar?",
                title: "Excluir avaliação",
                actions: { false: "Cancelar", true: "Excluir" },
            });

            if (!proceedAction) return;

            this.dataList.loading = true;

            try {
                await axios.delete(`/api/v1/assessments/${item.id}`);
                this.$dialog.notify.info("Avaliação excluída com sucesso!", { position: "top-right", timeout: 2000 });
                this.load();
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), { position: "top-right", timeout: 2000 });
            } finally {
                this.dataList.loading = false;
            }
        },
    },
};
</script>
